import { MS as c, WEBKIT as r, MOZ as f } from "./index.es114.js";
import { hash as h, replace as a, charat as s, strlen as d, indexof as o, match as i, substr as m } from "./index.es232.js";
function w(e, t, n) {
  switch (h(e, t)) {
    // color-adjust
    case 5103:
      return r + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return r + e + e;
    // tab-size
    case 4789:
      return f + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return r + e + f + e + c + e + e;
    // writing-mode
    case 5936:
      switch (s(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return r + e + c + a(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return r + e + c + a(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return r + e + c + a(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
    // flex, flex-direction, scroll-snap-type, writing-mode
    case 6828:
    case 4268:
    case 2903:
      return r + e + c + e + e;
    // order
    case 6165:
      return r + e + c + "flex-" + e + e;
    // align-items
    case 5187:
      return r + e + a(e, /(\w+).+(:[^]+)/, r + "box-$1$2" + c + "flex-$1$2") + e;
    // align-self
    case 5443:
      return r + e + c + "flex-item-" + a(e, /flex-|-self/g, "") + (i(e, /flex-|baseline/) ? "" : c + "grid-row-" + a(e, /flex-|-self/g, "")) + e;
    // align-content
    case 4675:
      return r + e + c + "flex-line-pack" + a(e, /align-content|flex-|-self/g, "") + e;
    // flex-shrink
    case 5548:
      return r + e + c + a(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return r + e + c + a(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return r + "box-" + a(e, "-grow", "") + r + e + c + a(e, "grow", "positive") + e;
    // transition
    case 4554:
      return r + a(e, /([^-])(transform)/g, "$1" + r + "$2") + e;
    // cursor
    case 6187:
      return a(a(a(e, /(zoom-|grab)/, r + "$1"), /(image-set)/, r + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return a(e, /(image-set\([^]*)/, r + "$1$`$1");
    // justify-content
    case 4968:
      return a(a(e, /(.+:)(flex-)?(.*)/, r + "box-pack:$3" + c + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + r + e + e;
    // justify-self
    case 4200:
      if (!i(e, /flex-|baseline/)) return c + "grid-column-align" + m(e, t) + e;
      break;
    // grid-template-(columns|rows)
    case 2592:
    case 3360:
      return c + a(e, "template-", "") + e;
    // grid-(row|column)-start
    case 4384:
    case 3616:
      return n && n.some(function(u, l) {
        return t = l, i(u.props, /grid-\w+-end/);
      }) ? ~o(e + (n = n[t].value), "span", 0) ? e : c + a(e, "-start", "") + e + c + "grid-row-span:" + (~o(n, "span", 0) ? i(n, /\d+/) : +i(n, /\d+/) - +i(e, /\d+/)) + ";" : c + a(e, "-start", "") + e;
    // grid-(row|column)-end
    case 4896:
    case 4128:
      return n && n.some(function(u) {
        return i(u.props, /grid-\w+-start/);
      }) ? e : c + a(a(e, "-end", "-span"), "span ", "") + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return a(e, /(.+)-inline(.+)/, r + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (d(e) - 1 - t > 6)
        switch (s(e, t + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            if (s(e, t + 4) !== 45)
              break;
          // (f)ill-available, (f)it-content
          case 102:
            return a(e, /(.+:)(.+)-([^]+)/, "$1" + r + "$2-$3$1" + f + (s(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          // (s)tretch
          case 115:
            return ~o(e, "stretch", 0) ? w(a(e, "stretch", "fill-available"), t, n) + e : e;
        }
      break;
    // grid-(column|row)
    case 5152:
    case 5920:
      return a(e, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(u, l, p, x, g, b, $) {
        return c + l + ":" + p + $ + (x ? c + l + "-span:" + (g ? b : +b - +p) + $ : "") + e;
      });
    // position: sticky
    case 4949:
      if (s(e, t + 6) === 121)
        return a(e, ":", ":" + r) + e;
      break;
    // display: (flex|inline-flex|grid|inline-grid)
    case 6444:
      switch (s(e, s(e, 14) === 45 ? 18 : 11)) {
        // (inline-)?fle(x)
        case 120:
          return a(e, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + r + (s(e, 14) === 45 ? "inline-" : "") + "box$3$1" + r + "$2$3$1" + c + "$2box$3") + e;
        // (inline-)?gri(d)
        case 100:
          return a(e, ":", ":" + c) + e;
      }
      break;
    // scroll-margin, scroll-margin-(top|right|bottom|left)
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return a(e, "scroll-", "scroll-snap-") + e;
  }
  return e;
}
export {
  w as prefix
};
//# sourceMappingURL=index.es234.js.map
